module.exports = __webpack_public_path__ + "static/media/ruth_english_us.96561ce8.mp3";